import { render } from "./family.vue?vue&type=template&id=0216b7e0"
import script from "./family.vue?vue&type=script&lang=js"
export * from "./family.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__